import styled from '@emotion/styled';
import UDNavLink from 'ud-ui/components/link/nav-link';

export const MainBlock = styled.div``;

const lineHeight = '30px';
const lineWidth = '10px';
const linePadding = '10px';

export const AppUL = styled.ul`
  padding-inline: 40px;
  list-style: none;
  position: relative;
  overflow: hidden;
  width: 100%;

  & li {
    // 8px - width of the Cup icon
    margin-left: calc(${lineWidth} + ${linePadding} + 8px);
    color: ${({ theme }) => theme.colors.WhiteGray};
    position: relative;
    margin-bottom: 8px;
  }

  & li::before {
    content: '';
    position: absolute;
    overflow: hidden;
    top: calc(10px - ${lineHeight});
    left: calc(-${lineWidth} - ${linePadding});
    width: ${lineWidth};
    height: ${lineHeight};
    border-left: 1px solid ${({ theme }) => theme.colors.Gray};
    border-bottom: 1px solid ${({ theme }) => theme.colors.Gray};
    border-radius: 0 0 0 4px;
  }
`;

export const TournamentItem = styled(UDNavLink)`
  display: -webkit-box;

  line-clamp: 1;
  -webkit-line-clamp: 1;

  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500 !important;
  transition: color 0.2s ease;
  font-size: 14px !important;
  line-height: 20px !important;
`;

export const TournamentLabel = styled.span`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
